import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MeinProjekt } from '../models/mein-projekt.model';

@Injectable({ providedIn: 'root' })
export class MeineProjekteService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/me/dashboard/projekte`;

  laden(): Observable<MeinProjekt[]> {
    return this.http.get<MeinProjekt[]>(this.apiUrl);
  }
}
